import React from "react";
import Headers from "../../Components/Headers";
import { useNavigate } from "react-router-dom";
import image1 from "../../Assets/image1.jpg";
import image2 from "../../Assets/image2.jpeg";
import image3 from "../../Assets/image3.png";
import Footer from "../../Components/Footers";

function Projects() {
  const navigate = useNavigate();

  const baseItems = [
    { img: image1, title: "Wandering Womb", subtitle: "drawing series" },
    { img: image2, title: "Immersive Reading", subtitle: "MU Hybrid Art House" },
    { img: image3, title: "Interactive Installation", subtitle: "Huiden Club" },
  ];

  const items = Array.from({ length: 9 }).map((_, i) => baseItems[i % baseItems.length]);

  return (
    <div className="custom-section">
      <Headers />
      <div className="project-page">
        <h1 className="page-title mt-5 mx-5">MoM Projects</h1>

        <div className="projects-grid mx-5">
          {items.map((it, idx) => (
            <div
              key={idx}
              className="project-card"
              onClick={() => navigate("/exhibitions")}
              role="button"
              tabIndex={0}
              onKeyDown={(e) => { if (e.key === "Enter") navigate("/exhibitions"); }}
            >
              <div className="project-image-wrap">
                <img src={it.img} alt={it.title} className="project-image" />
              </div>

              <div className="project-text">
                <div className="project-title">{it.title}</div>
                <div className="project-subtitle">{it.subtitle}</div>
              </div>
            </div>
          ))}
        </div>
      </div>
      <Footer/>
    </div>
  );
}

export default Projects;
